const storage = {
    not_configured: 'Провайдер хранилища не настроен.',
    missing_parameter: 'Отсутствует параметр {{parameter}} для провайдера хранилища.',
    upload_error: 'Не удалось загрузить файл в провайдер хранилища.',
};
export default storage;
